{
  "address_editing": {
    "address": "Address editing is allowed in My Account",
    "both_on": "Customers can add and edit all addresses",
    "both_off": "Address editing is restricted"
  },
  "checkout": {
    "enabled": "Checkout is enabled",
    "disabled": "Checkout is disabled"
  },
  "quoting_engine": {
    "enabled": "Customers can request quotes",
    "disabled": "Quote requests are disabled",
    "features_not_enabled": "The quoting engine feature is not enabled"
  },
  "credit_settings": {
    "blocked": "Checkout blocked if limit exceeded",
    "allowed": "Credit limits are not enforced"
  },
  "stock_location": {
    "all_locations": "Fulfill from all locations",
    "fulfillment_from": "Fulfillment from {location}",
    "not_found": "Location not found",
    "features_not_enabled": "The stock location feature is not enabled"
  },
  "order_quantity": {
    "minimum_only": "{min} {min, plural, =1 {item} other {items}}+",
    "range": "{min} - {max} items",
    "not_set": "No quantity limits set"
  },
  "order_total": {
    "minimum_only": "{min}+",
    "range": "{min} - {max}",
    "not_set": "No total limits set"
  },
  "recurring_orders": {
    "enabled": "Recurring orders is enabled",
    "disabled": "Recurring orders is disabled",
    "features_not_enabled": "The recurring orders feature is not enabled"
  },
  "stock_display": "Availability: {availability}, Pre-order: {pre_order}, Units: {units}, Max: {max}, Low: {low}, Last {last}",
  "on": "On",
  "off": "Off"
}
